import { render, staticRenderFns } from "./UpdateWeight.vue?vue&type=template&id=e334c52a&"
import script from "./UpdateWeight.vue?vue&type=script&lang=js&"
export * from "./UpdateWeight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports